import { useMemo } from "react";
import useWindowResize from "./useWIndowResize";

const useResponsiveImages = (config = {}) => {
    const { width } = useWindowResize();
    const selectedConfig = useMemo(
        () => Object.keys(config).find(breakpoint => breakpoint <= width),
        [config, width]
    );
    return selectedConfig ? config[selectedConfig] : config.default;
};

export default useResponsiveImages;
